import { SubscriptionCancelSurvey1stForm } from "./subscription-cancel-survey-1st.types";

export const initialValues: SubscriptionCancelSurvey1stForm = {
  whyCancel: "",
  whatLiked: "",
  whatUseFull: "",
};
